module.exports = __webpack_public_path__ + "img/contrato.0dab0501.jpg";